export const CLUB_PRODUCTS = {
	bold: 54727,
	bright: 54728,
	explorer: 54729,
	fearless: 54730,
	uno_blanco: 54731,
	uno_tinto: 54732,
	wild: 55549,
	explorer_plus: 55674,
	chido: 55804,
	experiencias: 55829
}

export const CLUB_PRODUCT_IDS = Object.values(CLUB_PRODUCTS)

export const CLUB_OPTIONS = [
	{ value: 'uno_blanco', label: 'Uno (Blanco)' },
	{ value: 'uno_tinto', label: 'Uno (Tinto)' },
	{ value: 'explorer', label: 'Explorer' },
	{ value: 'fearless', label: 'Fearless' },
	{ value: 'bold', label: 'Bold' },
	{ value: 'bright', label: 'Bright' },
	{ value: 'wild', label: 'Wild' },
	{ value: 'explorer_plus', label: 'Explorer Plus' },
	{ value: 'nunca_sin_vino', label: 'Cava' },
	{ value: 'chido', label: 'Club Chido' },
	{ value: 'experiencias', label: 'Club Experiencias' }
]

export function getClubName(club) {
	return CLUB_OPTIONS.find((option) => option.value === club)?.label || club || ''
}

// Recurring-charge reports must ignore NSV while preserving historical club records,
// including those without a billing frequency.
export function getClubSubscriptions(subscriptions) {
	return (subscriptions || []).filter((subscription) => subscription.club !== 'nunca_sin_vino')
}
